


























































































import {Component, Prop} from 'vue-property-decorator';
import Form from '@/components/form-base';
import {DialogForm, FormOverlay} from '@/components/bwaff';
import {pick} from 'lodash';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';

@Component({
  components: {
    FormOverlay,
    DialogForm,
    WorkspaceSelect,
  }
})
export default class CreateApiKeys extends Form {
  step=1;
  loading=false;
  formStep1={
    accessLevel:'readOnly',
    workspaceId:[],
    allowUrlAccess: true,
  }

  @Prop() data!: any;

  form: any = {};

  get isEdit() {
    return !!this.data?.apiKey;
  }

  created() {
    if (!this.isEdit) return;
    const apiKey = this.data.apiKey;
    this.formStep1 = {
      accessLevel: apiKey.accessLevel,
      workspaceId: apiKey.workspaceIds || [],
      allowUrlAccess: Boolean(apiKey.allowUrlAccess ?? true),
    };
  }

  close() {
    this.$emit('close');
  }

  submit() {
    if (this.isEdit) {
      if (this.formStep1.allowUrlAccess) {
        this.close();
        return;
      }
      this.loading = true;
      return this.data.api.patchApiKey(this.data.apiKey.accessKey, {
        allowUrlAccess: false,
      }).then(async () => {
        await this.data.api.getApiKeys();
        this.loading = false;
        this.close();
      }).catch(() => {
        this.loading = false;
      });
    }

    this.loading = true;
    return this.data.api.postCreateApiKey({
      accessLevel:this.formStep1.accessLevel,
      workspaceIds:this.formStep1.workspaceId,
      allowUrlAccess: this.formStep1.allowUrlAccess,
    }).then(async () => {
      await this.data.api.getApiKeys();
      this.form = {
        ...pick(this.data.api.newKey, [
          'accessKey',
          'secretKey'
        ])
      };
      this.step=2;
      this.loading = false;
    });
  }
}
